var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      staticClass: "sl-modal",
      attrs: {
        id: "draftStudentModal",
        "no-esc-dismiss": true,
        "no-backdrop-dismiss": true,
        maximized: _vm.maximized,
        "content-css": { width: "1000px", height: "800px" }
      },
      model: {
        value: _vm.draftStudentModalOpen,
        callback: function($$v) {
          _vm.draftStudentModalOpen = $$v
        },
        expression: "draftStudentModalOpen"
      }
    },
    [
      _c(
        "q-inner-loading",
        { attrs: { visible: _vm.draftStudentsLoading } },
        [_c("q-spinner-puff", { attrs: { color: "primary", size: "70" } })],
        1
      ),
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c(
                "q-toolbar-title",
                [
                  _c("q-icon", { attrs: { name: "fa fa-clipboard" } }),
                  _vm._v("\n        Draft Student Review\n      ")
                ],
                1
              ),
              _c("q-icon", {
                attrs: { name: "clear" },
                nativeOn: {
                  click: function($event) {
                    _vm.close()
                  }
                }
              })
            ],
            1
          ),
          _c("div", { staticClass: "sl-row header-row full-height" }, [
            _c("div", { staticClass: "sl-col-5 flex flex-center" }, [
              _c(
                "div",
                {
                  staticClass: "q-pa-md",
                  staticStyle: { width: "90%", "max-width": "500px" }
                },
                [
                  _c("h6", { staticClass: "q-mb-md text-center" }, [
                    _vm._v(
                      "Student " +
                        _vm._s(_vm.currentIndex + 1) +
                        " of " +
                        _vm._s(_vm.draftStudents.length)
                    )
                  ]),
                  _vm.draftStudents.length > 0
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "row q-mb-sm" },
                          [
                            _c("q-input", {
                              staticClass: "col-7 q-mr-sm",
                              attrs: {
                                "float-label": "Drivers License #",
                                autofocus: ""
                              },
                              model: {
                                value:
                                  _vm.draftStudents[_vm.currentIndex].DL_NUMBER,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.draftStudents[_vm.currentIndex],
                                    "DL_NUMBER",
                                    $$v
                                  )
                                },
                                expression:
                                  "draftStudents[currentIndex].DL_NUMBER"
                              }
                            }),
                            _c("q-select", {
                              staticClass: "col",
                              attrs: {
                                options: _vm.stateOptions,
                                "float-label": "Drivers License State",
                                outlined: "",
                                "emit-value": "",
                                "map-options": "",
                                "transition-show": "scale",
                                "transition-hide": "scale"
                              },
                              model: {
                                value:
                                  _vm.draftStudents[_vm.currentIndex].DL_STATE,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.draftStudents[_vm.currentIndex],
                                    "DL_STATE",
                                    $$v
                                  )
                                },
                                expression:
                                  "draftStudents[currentIndex].DL_STATE"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "row q-mb-sm" },
                          [
                            _c("q-input", {
                              staticClass: "col q-mr-sm",
                              attrs: { "float-label": "First Name" },
                              model: {
                                value:
                                  _vm.draftStudents[_vm.currentIndex]
                                    .FIRST_NAME,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.draftStudents[_vm.currentIndex],
                                    "FIRST_NAME",
                                    $$v
                                  )
                                },
                                expression:
                                  "draftStudents[currentIndex].FIRST_NAME"
                              }
                            }),
                            _c("q-input", {
                              staticClass: "col q-mr-sm",
                              attrs: { "float-label": "Last Name", filled: "" },
                              model: {
                                value:
                                  _vm.draftStudents[_vm.currentIndex].LAST_NAME,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.draftStudents[_vm.currentIndex],
                                    "LAST_NAME",
                                    $$v
                                  )
                                },
                                expression:
                                  "draftStudents[currentIndex].LAST_NAME"
                              }
                            }),
                            _c("q-input", {
                              staticClass: "col",
                              attrs: {
                                "float-label": "Middle Name",
                                filled: ""
                              },
                              model: {
                                value:
                                  _vm.draftStudents[_vm.currentIndex]
                                    .MIDDLE_NAME,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.draftStudents[_vm.currentIndex],
                                    "MIDDLE_NAME",
                                    $$v
                                  )
                                },
                                expression:
                                  "draftStudents[currentIndex].MIDDLE_NAME"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "row q-mb-sm" },
                          [
                            _c("q-input", {
                              staticClass: "col q-mr-sm",
                              attrs: { "float-label": "Address", filled: "" },
                              model: {
                                value:
                                  _vm.draftStudents[_vm.currentIndex].ADDRESS1,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.draftStudents[_vm.currentIndex],
                                    "ADDRESS1",
                                    $$v
                                  )
                                },
                                expression:
                                  "draftStudents[currentIndex].ADDRESS1"
                              }
                            }),
                            _c("q-input", {
                              staticClass: "col-3",
                              attrs: { "float-label": "Address 2", filled: "" },
                              model: {
                                value:
                                  _vm.draftStudents[_vm.currentIndex].ADDRESS2,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.draftStudents[_vm.currentIndex],
                                    "ADDRESS2",
                                    $$v
                                  )
                                },
                                expression:
                                  "draftStudents[currentIndex].ADDRESS2"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "row q-mb-sm" },
                          [
                            _c("q-input", {
                              staticClass: "col q-mr-sm",
                              attrs: { "float-label": "City", filled: "" },
                              model: {
                                value: _vm.draftStudents[_vm.currentIndex].CITY,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.draftStudents[_vm.currentIndex],
                                    "CITY",
                                    $$v
                                  )
                                },
                                expression: "draftStudents[currentIndex].CITY"
                              }
                            }),
                            _c("q-select", {
                              staticClass: "col-2 q-mr-sm",
                              attrs: {
                                options: _vm.stateOptions,
                                "float-label": "State",
                                outlined: "",
                                "emit-value": "",
                                "map-options": "",
                                "transition-show": "scale",
                                "transition-hide": "scale",
                                filled: ""
                              },
                              model: {
                                value:
                                  _vm.draftStudents[_vm.currentIndex].STATE,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.draftStudents[_vm.currentIndex],
                                    "STATE",
                                    $$v
                                  )
                                },
                                expression: "draftStudents[currentIndex].STATE"
                              }
                            }),
                            _c("q-input", {
                              staticClass: "col-3",
                              attrs: { "float-label": "Zip", filled: "" },
                              model: {
                                value: _vm.draftStudents[_vm.currentIndex].ZIP,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.draftStudents[_vm.currentIndex],
                                    "ZIP",
                                    $$v
                                  )
                                },
                                expression: "draftStudents[currentIndex].ZIP"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "row q-mb-sm" },
                          [
                            _c("q-select", {
                              staticClass: "col-3 q-mr-sm",
                              attrs: {
                                options: _vm.genderOptions,
                                "float-label": "Gender",
                                outlined: "",
                                "emit-value": "",
                                "map-options": "",
                                "transition-show": "scale",
                                "transition-hide": "scale"
                              },
                              model: {
                                value:
                                  _vm.draftStudents[_vm.currentIndex].GENDER,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.draftStudents[_vm.currentIndex],
                                    "GENDER",
                                    $$v
                                  )
                                },
                                expression: "draftStudents[currentIndex].GENDER"
                              }
                            }),
                            _c("q-input", {
                              staticClass: "col q-mr-sm",
                              attrs: {
                                "error-message": "MM/DD/YYYY",
                                error: _vm.fieldHasError("DOB"),
                                before: [{ icon: "calendar_today" }],
                                "float-label": "Date of Birth",
                                filled: "",
                                format: "MM/DD/YYYY"
                              },
                              on: { blur: _vm.dateBlur },
                              model: {
                                value: _vm.draftStudents[_vm.currentIndex].DOB,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.draftStudents[_vm.currentIndex],
                                    "DOB",
                                    $$v
                                  )
                                },
                                expression: "draftStudents[currentIndex].DOB"
                              }
                            }),
                            _c("q-input", {
                              staticClass: "col",
                              attrs: { "float-label": "Phone", filled: "" },
                              model: {
                                value:
                                  _vm.draftStudents[_vm.currentIndex].PHONE,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.draftStudents[_vm.currentIndex],
                                    "PHONE",
                                    $$v
                                  )
                                },
                                expression: "draftStudents[currentIndex].PHONE"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "row q-mb-sm justify-center" },
                          [
                            _c("q-input", {
                              staticClass: "col-6 q-mr-sm",
                              attrs: {
                                "error-message": "MM/DD/YYYY",
                                error: _vm.fieldHasError("COMPLETION_DATE"),
                                before: [{ icon: "calendar_today" }],
                                "float-label": "Completion Date",
                                filled: "",
                                format: "MM/DD/YYYY"
                              },
                              model: {
                                value:
                                  _vm.draftStudents[_vm.currentIndex]
                                    .COMPLETION_DATE,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.draftStudents[_vm.currentIndex],
                                    "COMPLETION_DATE",
                                    $$v
                                  )
                                },
                                expression:
                                  "draftStudents[currentIndex].COMPLETION_DATE"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "row justify-center q-mt-lg" },
                          [
                            _c("q-btn", {
                              staticClass: "q-mr-md",
                              attrs: {
                                disable:
                                  _vm.currentIndex === 0 || _vm.studentHasError,
                                color: "primary",
                                icon: "arrow_back",
                                label: "Previous",
                                outline: ""
                              },
                              on: { click: _vm.previousStudent }
                            }),
                            _c("q-btn", {
                              attrs: {
                                disable:
                                  _vm.currentIndex ===
                                    _vm.draftStudents.length - 1 ||
                                  _vm.studentHasError,
                                color: "primary",
                                "icon-right": "arrow_forward",
                                outline: "",
                                label: "Next"
                              },
                              on: { click: _vm.nextStudent }
                            })
                          ],
                          1
                        )
                      ])
                    : _c("div", { staticClass: "text-center" }, [
                        _vm._v(
                          "\n            No students to review\n          "
                        )
                      ])
                ]
              )
            ]),
            _c("div", { staticClass: "sl-col-7 full-height" }, [
              _vm.foundDocument
                ? _c("iframe", {
                    ref: "rosterFrame",
                    staticStyle: { width: "100%", height: "100%" }
                  })
                : _c("div", { staticClass: "flex flex-center full-height" }, [
                    _vm._v("Could not find roster")
                  ])
            ])
          ]),
          _c(
            "q-toolbar",
            {
              staticClass: "sl-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("q-toolbar-title"),
              _c("q-btn", {
                staticClass: "q-mr-sm",
                attrs: {
                  color: "green",
                  label: "Finish",
                  disable: _vm.draftStudentsLoading
                },
                on: {
                  click: function($event) {
                    _vm.completeReview()
                  }
                }
              }),
              _c("q-btn", {
                staticClass: "q-mr-sm",
                attrs: {
                  color: "primary",
                  label: "Save & Close",
                  disable: _vm.draftStudentsLoading
                },
                on: {
                  click: function($event) {
                    _vm.saveAndClose()
                  }
                }
              }),
              _c("q-btn", {
                attrs: { outline: "", color: "faded", label: "Cancel" },
                on: {
                  click: function($event) {
                    _vm.close()
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }